import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  segmentsApi,
  type UpdateSegmentRequest,
} from '@/api/segments/segmentsApi'
import { segmentsQueries } from '@/api/segments/segmentsQueries'

export const useUpdateSegmentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string
      payload: UpdateSegmentRequest
    }) => segmentsApi.updateSegment(id, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: segmentsQueries.all() }),
  })
}
